import { KeyNumberElement } from "../../interfaces/transaction/transaction";
import React from "react";
import { Options } from "../options/option";
import { PriceCheck, Store, Storefront } from "@mui/icons-material";
import { ManagableColumn } from "interfaces/table/table";

export const PORTFOLIO_KEY_NUMBERS: Record<string, KeyNumberElement> = {
  NUMBER_OF_MERCHANT: {
    id: "nbEntities",
    label: "portf_merchants",
    icon: <Storefront />,
  },
  NUMBER_OF_COMPANY: {
    id: "nbEntities",
    label: "portf_companies",
    icon: <Store />,
  },
  TOTAL_DISTRIBUTOR_COMISSION: {
    id: "totalDistributorComission",
    label: "portf_dist_com",
    currency: true,
    icon: <PriceCheck />,
  },
  TOTAL_COMMISSION: {
    id: "totalCommission",
    label: "total_fees",
    currency: true,
    icon: <PriceCheck />,
  },
};

export const PORTFOLIO_TOP_SORTING: Array<Options> = [
  { id: "numberOfTransaction", name: "portf_col_nbr_tx" },
  { id: "grossAmount", name: "portf_col_gross_sum" },
  { id: "successRate", name: "portf_col_success_rate" },
];

//------Portfolio Columns----------------------

export const PORTFOLIO_COLUMNS: Record<string, ManagableColumn> = {
  ID: {
    id: "ID",
    accessor: "id",
    header: "rank",
    order: 0,
    cell: {
      type: "text",
    },
    options: {
      maxWidth: 30,
      width: 30,
      minWidth: 30,
    },
    disableSortBy: true,

  },
  COMPANY_NAME: {
    id: "COMPANY_NAME",
    accessor: "COMPANY_NAME",
    header: "tpd_company_name",
    order: 1,
    cell: {
      type: "text",
    },
    disableSortBy: true,
  },
  MERCHANT_NAME: {
    id: "MERCHANT_NAME",
    accessor: "MERCHANT_NAME",
    header: "tpd_merchant_name",
    order: 1,
    cell: {
      type: "text",
    },
    disableSortBy: true,
  },
  NUMBER_TRANSACTION: {
    id: "NUMBER_TRANSACTION",
    accessor: "NUMBER_TRANSACTION",
    header: "portf_col_nbr_tx",
    order: 2,
    cell: {
      type: "text",
      defaultValue: "0",
    },
  },
  GROSS_AMOUNT: {
    id: "GROSS_AMOUNT",
    accessor: "GROSS_AMOUNT",
    header: "portf_col_gross_sum",
    order: 3,
    cell: {
      type: "money",
      defaultValue: "0",
    },
  },
  SUCCESS_RATE: {
    id: "SUCCESS_RATE",
    accessor: "SUCCESS_RATE",
    header: "portf_col_success_rate",
    order: 4,
    cell: {
      type: "percent",
      defaultValue: "",
    },
    disableSortBy: true,
  },
  DISTRIBUTOR_COMMISSION: {
    id: "DISTRIBUTOR_COMMISSION",
    accessor: "DISTRIBUTOR_COMMISSION",
    header: "portf_col_dist_com",
    order: 5,
    cell: {
      type: "money",
      defaultValue: "0",
    },
    disableSortBy: true,
  },
  MARKET_PAY_COMMISSION: {
    id: "MARKET_PAY_COMMISSION",
    accessor: "MARKET_PAY_COMMISSION",
    header: "portf_col_mp_com",
    order: 6,
    cell: {
      type: "money",
      defaultValue: "0",
    },
    disableSortBy: true,
  },
  AVG_COMMISSION_RATE: {
    id: "AVG_COMMISSION_RATE",
    accessor: "AVG_COMMISSION_RATE",
    header: "portf_col_avg_com_rate",
    order: 7,
    cell: {
      type: "percent",
      defaultValue: "",
    },
    disableSortBy: true,
  },

  TOTAL_COMMISSION: {
    id: "TOTAL_COMMISSION",
    accessor: "TOTAL_COMMISSION",
    header: "portf_col_total_commission",
    order: 8,
    cell: {
      type: "money",
      defaultValue: "0",
    },
    disableSortBy: true,
  },
  
}

//------Portfolio trends column----------------
export const TRENDS_PORTFOLIO_COLUMNS: Record<string, ManagableColumn> = {
  ID: {
    id: "ID",
    accessor: "id",
    header: "rank",
    order: 0,
    cell: {
      type: "text",
    },
    options: {
      maxWidth: 25,
      minWidth: 20,
    },
    disableSortBy: true,
  },
  MERCHANT_NAME: {
    id: "MERCHANT_NAME",
    accessor: "merchant",
    header: "tpd_merchant_name",
    order: 1,
    cell: {
      type: "text",
    },
    disableSortBy: true,
  },
  NUMBER_TRANSACTION: {
    id: "MERCHANT_NAME",
    accessor: "numberOfTransactions",
    header: "portf_col_nbr_tx",
    order: 2,
    cell: {
      type: "text",
      defaultValue: "0",
    },
    disableSortBy: true,
    tooltip: "portf_tooltip_nbr_tx"
  },
  GROSS_AMOUNT: {
    id: "GROSS_AMOUNT",
    accessor: "grossAmount",
    header: "portf_col_gross_sum",
    order: 3,
    cell: {
      type: "money",
      defaultValue: "0",
    },
    disableSortBy: true,
    tooltip: "portf_tooltip_gross"
  },
  DAY_PERCENTAGE_VOLUME: {
    id: "DAY_PERCENTAGE_VOLUME",
    accessor: "RATE_VOLUME_EVOLUTION_DAY",
    header: "portf_col_day",
    order: 4,
    cell: {
      type: "percent",
      defaultValue: "",
    },
    tooltip: "portf_col_day_tooltip"
  },
  WEEK_PERCENTAGE_VOLUME: {
    id: "WEEK_PERCENTAGE_VOLUME",
    accessor: "RATE_VOLUME_EVOLUTION_WEEK",
    header: "portf_col_week",
    order: 5,
    cell: {
      type: "percent",
      defaultValue: "",
    },
    tooltip: "portf_col_week_tooltip"
  },
  MONTH_PERCENTAGE_VOLUME: {
    id: "MONTH_PERCENTAGE_VOLUME",
    accessor: "RATE_VOLUME_EVOLUTION_MONTH",
    header: "portf_col_month",
    order: 6,
    cell: {
      type: "percent",
      defaultValue: "",
    },
    tooltip: "portf_col_month_tooltip"
  },
  DAY_PERCENTAGE_AMOUNT: {
    id: "DAY_PERCENTAGE",
    accessor: "RATE_AMOUNT_EVOLUTION_DAY",
    header: "portf_col_day",
    order: 4,
    cell: {
      type: "percent",
      defaultValue: "",
    },
    tooltip: "portf_col_day_tooltip"
  },
  WEEK_PERCENTAGE_AMOUNT: {
    id: "WEEK_PERCENTAGE",
    accessor: "RATE_AMOUNT_EVOLUTION_WEEK",
    header: "portf_col_week",
    order: 5,
    cell: {
      type: "percent",
      defaultValue: "",
    },
    tooltip: "portf_col_week_tooltip"
  },
  MONTH_PERCENTAGE_AMOUNT: {
    id: "MONTH_PERCENTAGE",
    accessor: "RATE_AMOUNT_EVOLUTION_MONTH",
    header: "portf_col_month",
    order: 6,
    cell: {
      type: "percent",
      defaultValue: "",
    },
    tooltip: "portf_col_month_tooltip"
  },
};
